import { Outlet, useLocation } from "react-router-dom";
import { Logo, ThemeToggle } from "@promptgatewaysadmin/ui";

/** Per-screen max widths, from the layout spec. */
const WIDTHS: Record<string, number> = {
  "/onboarding": 900,
  "/checkout": 480,
  "/checkout/success": 440,
  "/checkout/cancelled": 440,
  "/404": 420,
};

/**
 * Archetype C — centred, full-bleed, with a per-screen max width. Used by onboarding, the
 * three checkout screens, and 404. No sidebar: these are single-purpose screens where a nav
 * rail would invite the customer to wander out of a funnel they are mid-way through.
 */
export function StandaloneLayout() {
  const { pathname } = useLocation();
  const width = WIDTHS[pathname] ?? 560;
  return (
    <div className="pg-standalone">
      <a href="#main" className="pg-skip">
        Skip to main content
      </a>
      <header className="pg-standalone__header">
        <Logo />
        <ThemeToggle />
      </header>
      <main
        id="main"
        tabIndex={-1}
        className="pg-standalone__main"
        style={{ maxWidth: `${width}px` }}
      >
        <Outlet />
      </main>
    </div>
  );
}
